/* eslint-disable class-methods-use-this */
import React from "react";
import { DashboardGroupBy } from "../../../__generated__/api";
import Avatar from "../../../components/avatar/Avatar";
import TicketItem from "../ticket-item";
import { GROUP_REGISTRY, GroupBy, GroupDescriptor } from "./base";

export default class RequesterGroupBy extends GroupBy {
    public static shouldCreate(groupBy: DashboardGroupBy): boolean {
        return groupBy === DashboardGroupBy.User;
    }

    public getGroup(id: string, chats: TicketItem[]): GroupDescriptor {
        const firstChat = chats[0];

        const user = firstChat.ticket?.creator ?? firstChat.ticket?.requestor ?? firstChat.chat.creator;
        return {
            id,
            icon: <Avatar src={user?.avatarUrl as string} />,
            title: user?.name as string,
            subtitle: user.organization?.name ?? user.group as string,
        };
    }

    public getGroupId(ticket: TicketItem): string | undefined {
        return ticket.ticket?.requestorId ?? ticket.chat.creatorId;
    }
}

GROUP_REGISTRY.register(RequesterGroupBy);
